import React from 'react';

export const Ellipse: React.FC = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='3.5' cy='12' r='2.5' />
    <circle cx='12' cy='12' r='2.5' />
    <circle cx='20.5' cy='12' r='2.5' />
  </svg>
);
